// Normalizovaný interní datový model BCF (§3). NENÍ přímou reprezentací XML —
// je to aplikační model nezávislý na verzi BCF (2.1/3.0). Parsery do něj mapují
// a writery z něj generují. Entity: BCFProject, BCFTopic, BCFComment,
// BCFViewpoint, BCFComponent(Ref), BCFSnapshot, BCFDocumentReference, WorkflowState.
import { guid } from "./ids.js";

export function nowISO() { return new Date().toISOString(); }

// Odkaz na IFC prvek — vždy modelId + GlobalId (§9, §28). expressID/runtime ID
// se zde NEUKLÁDÁ; převádí ho ComponentResolver za běhu.
export function componentRef({ modelId = null, globalId, authoringToolId = null, originatingSystem = null } = {}) {
  return { modelId, globalId, authoringToolId, originatingSystem };
}

export function createProject({ projectId = guid(), name = "BCF projekt" } = {}) {
  return { projectId, name, topics: [] };
}

export function createTopic(data = {}) {
  return {
    id: data.id || guid(),
    title: data.title || "Bez názvu",
    description: data.description || "",
    type: data.type || null,
    status: data.status || "new",
    priority: data.priority || null,
    stage: data.stage || null,
    assignedTo: data.assignedTo || null,
    createdBy: data.createdBy || null,
    modifiedBy: data.modifiedBy || null,
    createdAt: data.createdAt || nowISO(),
    modifiedAt: data.modifiedAt || null,
    dueDate: data.dueDate || null,
    labels: Array.isArray(data.labels) ? data.labels.slice() : [],
    referenceLinks: Array.isArray(data.referenceLinks) ? data.referenceLinks.slice() : [],
    documentReferences: Array.isArray(data.documentReferences) ? data.documentReferences.slice() : [],
    comments: Array.isArray(data.comments) ? data.comments : [],
    viewpoints: Array.isArray(data.viewpoints) ? data.viewpoints : [],
    workflow: data.workflow || null,           // { state } — řídí WorkflowService
    audit: Array.isArray(data.audit) ? data.audit : [],
    sourceVersion: data.sourceVersion || "3.0",
  };
}

export function createComment(data = {}) {
  return {
    id: data.id || guid(),
    author: data.author || null,
    date: data.date || nowISO(),
    modifiedAuthor: data.modifiedAuthor || null,
    modifiedDate: data.modifiedDate || null,
    text: data.text || "",
    viewpointId: data.viewpointId || null,      // volitelný odkaz na viewpoint (§17)
  };
}

// BCFViewpoint — prostorová záložka (§10-§16). Kamera/clipping v IFC souřadnicích.
export function createViewpoint(data = {}) {
  return {
    id: data.id || guid(),
    index: data.index != null ? data.index : null,
    camera: data.camera || null,                // { type, position, direction, up, fieldOfView?, viewToWorldScale? }
    selection: Array.isArray(data.selection) ? data.selection : [],     // componentRef[]
    visibility: data.visibility || { defaultVisibility: true, exceptions: [] },
    clippingPlanes: Array.isArray(data.clippingPlanes) ? data.clippingPlanes : [], // { location, direction }
    coloring: Array.isArray(data.coloring) ? data.coloring : [],        // { color, components: ref[] }
    lines: Array.isArray(data.lines) ? data.lines : [],
    snapshot: data.snapshot || null,            // { type:'png', data:dataURL|Blob, fileName }
  };
}

export function documentReference(data = {}) {
  return {
    id: data.id || guid(),
    referencedDocument: data.referencedDocument || null,
    description: data.description || null,
    isExternal: data.isExternal !== false,
  };
}
